import React, { FC } from 'react';
import { Divider } from '@mui/material';

import { Stack } from 'Modules/ui3';

import { STATUSES_ORDER } from './consts';
import { DfaStatus } from '../DfaStatus';
import { EmissionStatus } from '../../api';
import { DfaStatusesModelProps, StatusBlockProps } from './types';
import { StatusVariant } from '../DfaStatus/types';


const StatusBlock: FC<StatusBlockProps> = ({ showDivider, ...props }) => (
    <>
        {showDivider && (
            <Divider
                orientation='vertical'
                sx={({ spacing }) => ({
                    height: spacing(2),
                    alignSelf: 'center',
                    borderRadius: 25,
                    borderColor: '#d9d9d9',
                })}
            />
        )}
        <DfaStatus {...props} />
    </>
);

export const DfaStatusesModel: FC<DfaStatusesModelProps> = ({ status, customText }) => {
    const activeIdx = STATUSES_ORDER.findIndex(s => s === status);
    return (
        <Stack spacing={1}>
            {STATUSES_ORDER.map((s, idx) => (
                <StatusBlock
                    key={s}
                    showDivider={idx !== 0}
                    status={s}
                    variant={idx === activeIdx
                        ? StatusVariant.active : idx < activeIdx || activeIdx === -1
                            ? StatusVariant.disabled : StatusVariant.default}
                />
            ))}
            {(status === EmissionStatus.other || status === EmissionStatus.failed) && (
                <StatusBlock showDivider status={status} customText={customText} />
            )}
        </Stack>
    );
};
